module.exports = __webpack_public_path__ + "img/successful-evaluation-assigned.6b064ee0.png";